import React, { useCallback, useState } from "react";

import {
    canRequestReload,
    noticeAfterRelease,
    withReloadCancelled,
    withReloadRequested
} from "./lib";

export const Context = React.createContext({
    notice: null,
    activateRelease: () => {},
    saveAndReload: () => {}
});

export const ReleaseActivatedContext = ({ children }) => {
    const [notice, setNotice] = useState(null);

    const activateRelease = useCallback((release, saveAndReload) => {
        setNotice(current => noticeAfterRelease(current, release, saveAndReload));
    }, []);

    const saveAndReload = useCallback(() => {
        if (!canRequestReload(notice)) {
            return;
        }
        setNotice(withReloadRequested(notice));
        Promise.resolve(notice.saveAndReload()).catch(() =>
            setNotice(current => withReloadCancelled(current))
        );
    }, [notice]);

    const state = {
        notice,
        activateRelease,
        saveAndReload
    };

    return <Context.Provider value={state}>{children}</Context.Provider>;
};

export default ReleaseActivatedContext;
